import PaymentOption from '../interfaces/paymentOption'
import useSWR from 'swr'
import { getPaymentMethods } from '../services/payment/payment.service'

export const usePaymentMethod = () => {
  const { data: paymentOptionsRequest } = useSWR('paymentMethods', getPaymentMethods)

  const findOption = (name: string, type: PaymentOption['type']) => {
    return paymentOptionsRequest?.paymentMethods
      .find(payment =>
        payment.paymentOption.name.includes(name) && payment.paymentOption.type.includes(type))
  }

  const getActiveGatewayCardMethod = () => paymentOptionsRequest?.paymentMethods.find(payment => payment.active === true && payment.paymentOption.type === 'gateway')

  const getStonePublicKey = (): string => {
    const stoneGatewayMethod = findOption('stone', 'gateway')

    const publicKey = stoneGatewayMethod?.extras[1] || 'pk_test_Lw7B2OxuzVIxQK09'

    return publicKey
  }

  return {
    getActiveGatewayCardMethod,
    getStonePublicKey,
    findOption
  }
}
